import React from 'react';
import { connect } from 'react-redux';
import Menu from '../menu';
import { Button, Icon, Input, Modal, Pagination, Table } from '../../components';
import { axios, Colors, Globals } from '../../utils';
import CloseIcon from '../../assets/icons/close-black.png';
import LeftArrowIcon from '../../assets/icons/left-arrow.png';

const STATUS = {
  PENDING: 0,
  DELIVERED: 1,
};

class CreateDispatchRoutes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form1: {
        admin_id: this.props.user.admin_id != null ? this.props.user.admin_id : this.props.user.id,
        user_id: this.props.user.id,
        search: '',
        page: 1,
        last_page: 1,
      },
      form2: {
        admin_id: this.props.user.admin_id != null ? this.props.user.admin_id : this.props.user.id,
        user_id: this.props.user.id,
        search: '',
        page: 1,
        last_page: 1,
      },
      data: [],
      routes: [],
      visibleRoute: null,
      focusedRoute: null,
      selectedOrders: [],
      filledRoutes: [],
    };
  }

  abortController = new AbortController()

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    this.abortController.abort()
  }

  load = () => {
    this.getOrders();
    this.getRoutes();
  }

  getOrders = async (page = 1) => {
    // Globals.setLoading();
    // let param = this.state.form;
    // param.user_id = this.props.user.id;
    // axios
    //   .post("web/admin/quotes?page=" + this.state.page, param)
    //   .then(res => {
    //     if (res.data.quotes) {
    //       this.setState({
    //         page,
    //         last_page: res.data.quotes.last_page,
    //         data: res.data.quotes.data,
    //         methods: res.data?.payment_methods,
    //         id_selected: []
    //       });
    //     }
    //   })
    //   .catch(err => {
    //     Globals.showError();
    //   })
    //   .then(() => {
    //     Globals.quitLoading();
    //   });

    this.setState({ data: [
      {
        id: 1,
        number_format: "3700",
        client: {
          name: "Distribuidora Burguer",
        },
        total: 95,
        route: 'Ruta 50',
        date: '2025-03-10',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 2,
        number_format: "3699",
        client: {
          name: "Abasto y Charcuteri A&J 2018",
        },
        total: 1100,
        route: 'Ruta 100',
        date: '2025-03-10',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 3,
        number_format: "3698",
        client: {
          name: "Comercial 88 C.A",
        },
        total: 195,
        route: 'Ruta este 50',
        date: '2025-03-10',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 4,
        number_format: "3697",
        client: {
          name: "Abasto y Charcuteri A&J 2018",
        },
        total: 125,
        route: 'Ruta norte 100',
        date: '2025-03-10',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 5,
        number_format: "3696",
        client: {
          name: "Distribuidora Burguer",
        },
        total: 95,
        route: 'Ruta 41',
        date: '2025-03-05',
        status: STATUS.PENDING,
        observations: '',
      },
      {
        id: 6,
        number_format: "3695",
        client: {
          name: "Abasto y Charcuteri A&J 2018",
        },
        total: 1100,
        route: 'Ruta norte 50',
        date: '2025-03-05',
        status: STATUS.PENDING,
        observations: '',
      },
    ] })
  };

  getRoutes = async (page = 1) => {
    // Globals.setLoading();
    // let param = this.state.form;
    // param.user_id = this.props.user.id;
    // axios
    //   .post("web/admin/quotes?page=" + this.state.page, param)
    //   .then(res => {
    //     if (res.data.quotes) {
    //       this.setState({
    //         page,
    //         last_page: res.data.quotes.last_page,
    //         data: res.data.quotes.data,
    //         methods: res.data?.payment_methods,
    //         id_selected: []
    //       });
    //     }
    //   })
    //   .catch(err => {
    //     Globals.showError();
    //   })
    //   .then(() => {
    //     Globals.quitLoading();
    //   });

    this.setState({ routes: [
      {
        id: 1,
        name: "Ruta 100",
      },
      {
        id: 2,
        name: "Ruta norte 50",
      },
      {
        id: 3,
        name: "Ruta norte 25",
      },
      {
        id: 4,
        name: "Ruta 50",
      },
      {
        id: 5,
        name: "Ruta 70",
      },
      {
        id: 6,
        name: "Ruta 10",
      },
      {
        id: 7,
        name: "Ruta 75",
      },
      {
        id: 8,
        name: "Ruta este15",
      },
      {
        id: 9,
        name: "Ruta 5",
      },
      {
        id: 10,
        name: "Ruta norte 30",
      },
    ] })
  };

  getStatus = (status) => {
    switch (status) {
      case STATUS.PENDING:
        return {
          text: "Por entregar",
          color: Colors.red,
        };

      case STATUS.DELIVERED:
        return {
          text: "Entregado",
          color: Colors.black,
        };

      default:
        return {
          text: "No definido",
          color: Colors.black,
        };
    }
  };

  handleChange = (value, target, form) => {
    const _form = Globals.copy(this.state[form]);
    _form[target] = value;
    this.setState({ [form]: _form });
  };

  toggleOrder = (item) => {
    const exists = this.state.selectedOrders.some(x => x.id === item.id);
    if (exists) {
      this.setState({ selectedOrders: this.state.selectedOrders.filter(x => x.id !== item.id) });
    } else {
      this.setState({ selectedOrders: [...this.state.selectedOrders, item] });
    }
  };

  selectRoute = (item) => {
    this.setState({ focusedRoute: item, selectedOrders: item?.orders ?? [] });
  };

  addSelectedOrdersToRoute = () => {
    if (!this.state.focusedRoute) Globals.showError('Debe seleccionar una ruta');
    if (!this.state.selectedOrders.length) Globals.showError('Debe seleccionar al menos un pedido');

    const newRoute = {
      route_id: this.state.focusedRoute.id,
      route: Globals.copy(this.state.focusedRoute),
      orders: Globals.copy(this.state.selectedOrders),
    };

    this.setState({
      filledRoutes: [...this.state.filledRoutes, newRoute],
      focusedRoute: null,
      selectedOrders: [],
    });
  };

  removeOrderFromRoute = (order) => {
    const newRoute = Globals.copy(this.state.visibleRoute);
    newRoute.orders = newRoute.orders.filter(x => x.id !== order.id);

    if (!newRoute.orders.length) {
      const others = this.state.filledRoutes.filter(x => x.route_id !== newRoute.route_id);
      this.setState({ visibleRoute: null, filledRoutes: others });
    } else {
      const routeIdx = this.state.filledRoutes.findIndex(x => x.route_id === newRoute.route_id);
      const routes = Globals.copy(this.state.filledRoutes);
      routes[routeIdx] = newRoute;
      this.setState({ visibleRoute: newRoute, filledRoutes: routes });
    }
  };

  viewRoute = (item) => {
    const route = Globals.copy(this.state.filledRoutes.find(x => x.route_id === item.id));
    this.setState({ visibleRoute: route });
  };

  close = () => {
    this.setState({ visibleRoute: null });
  };

  ordersValidator = (showError = true) => {
    const onError = (msg) => {
      if (showError) Globals.showError(msg);
      return false;
    };

    if (!this.state.focusedRoute)
      return onError('Debe seleccionar la ruta que le añadirá el/los pedido(s)');

    if (!this.state.selectedOrders.length)
      return onError('Debe seleccionar al menos un pedido');

    return true;
  };

  routesValidator = (showError) => {
    const onError = (msg) => {
      if (showError) Globals.showError(msg);
      return false;
    };

    if (!this.state.filledRoutes.length)
      return onError('Debe registrar al menos una ruta');

    return true;
  };

  submit = async () => {
    
  };

  render() {
    const { history } = this.props;
    const { data, visibleRoute } = this.state;
    const isAddBtnEnabled = this.ordersValidator(false);
    const isSaveBtnEnabled = this.routesValidator(false);

    return (
      <Menu
        history={history}
        leftSlot={<BackButton onClick={() => this.props.history.replace('/dispatch-routes')} />}
      >
        {visibleRoute && (
          <Modal title={visibleRoute?.route?.name} onClose={this.close} visible size="lg">
            <RouteDetails item={visibleRoute} onClose={this.close} onRemoveOrder={this.removeOrderFromRoute} />
          </Modal>
        )}

        <div id="dispatch-routes-create">
          <section id="orders">
            <div className="table-actions">
              <Input
                color=" "
                name="id"
                className="filter"
                placeholder="ID de rutas de despacho"
                value={this.state.form1.search}
                onChange={e => this.handleChange(e.target.value, 'search', 'form1')}
              />
              <div>
                <Button
                  style={{ padding: '0.5rem 1rem', borderRadius: '8px' }}
                  disabled={!isAddBtnEnabled}
                  onClick={this.addSelectedOrdersToRoute}
                >
                  Añadir
                </Button>
              </div>
            </div>

            <Table
              header={['N° de pedido','Cliente','Monto','Ruta de despacho','Estatus']}
              data={data.length}
            >
              {data.map((item, index) => {
                const status = this.getStatus(item.status);
                const isSelected = this.state.selectedOrders.some(x => x.id === item.id);
                return (
                  <tr key={index}>
                    <td>
                      <button
                        className={`checkbox ${isSelected ? 'checked' : ''}`}
                        onClick={() => this.toggleOrder(item)}
                      />
                      <span>{item.number_format}</span>
                    </td>
                    <td>{item.client?.name ?? 'No tiene'}</td>
                    <td align="right">{Globals.formatMiles(item.total)}</td>
                    <td>{item.route ?? 'No tiene'}</td>
                    <td>
                      <span style={{ color: status.color }}>{status.text}</span>
                    </td>
                  </tr>
                );
              })}
            </Table>

            <Pagination
              pages={this.state.form1.last_page}
              active={this.state.form1.page}
              onChange={page => this.load(page)}
            />
          </section>

          <section id="routes">
            <p className="title">Rutas</p>
            <Input
              color=" "
              name="id"
              className="filter"
              placeholder="Buscar ruta"
              value={this.state.form2.search}
              onChange={e => this.handleChange(e.target.value, 'search', 'form2')}
            />
            <p className="tip">Seleccione la ruta que le añadirá el/los pedido(s)</p>

            <div className="route-list">
              {this.state.routes.map((item, index) => {
                const isFocused = this.state.focusedRoute?.id === item.id;
                const isFilled = this.state.filledRoutes.some(x => x?.route_id === item.id);
                return (
                  <div
                    key={index}
                    className={`route-item ${isFocused ? 'focused' : ''} ${isFilled ? 'filled' : ''}`}
                    onClick={() => isFilled ? this.viewRoute(item) : this.selectRoute(item)}
                  >
                    {isFilled && <Icon name="check" />}
                    <p>{item.name}</p>
                    {isFilled && <Icon name="eye" />}
                  </div>
                );
              })}
            </div>

            {!this.state.routes.length && (
              <p className="no-items">No hay registros</p>
            )}

            <div className="actions">
              <Button
                style={{ padding: '0.5rem 1rem', borderRadius: '8px' }}
                disabled={!isSaveBtnEnabled}
                onClick={this.submit}
              >
                Guardar
              </Button>
            </div>
          </section>
        </div>
      </Menu>
    );
  }
}

const BackButton = ({ onClick }) => (
  <>
    <div className="back-button">
      <img src={ LeftArrowIcon } onClick={() => onClick()} alt="Regresar" />
    </div>
    <div className="content-breadcumbs">
      <div className="title">Asignar pedidos a ruta de despacho</div>
    </div>
  </>
);

const RouteDetails = ({ item, onClose, onRemoveOrder }) => {
  return (
    <div id="dispatch-routes-details">
      <Table
        header={['N° de pedido', 'Cliente', 'Monto', 'Ruta de despacho']}
        data={item?.orders?.length}
      >
        {item?.orders?.map((order, index) => {
          return (
            <tr key={index}>
              <td>
                <img className="delete-icon" src={CloseIcon} onClick={() => onRemoveOrder(order)} alt="Eliminar pedido" />
                <span>{order.number_format}</span>
              </td>
              <td>{order.client?.name ?? 'No tiene'}</td>
              <td align="right">{Globals.formatMiles(order.total)}</td>
              <td>{order.route ?? 'No tiene'}</td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
};

export default connect(state => {
  return {
    user: state.user
  };
})(CreateDispatchRoutes);
